import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/hosting/app/components/homepage/BlogSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/hosting/app/components/homepage/EventTypes.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/hosting/app/components/homepage/FindEventSpaces.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/hosting/app/components/homepage/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/hosting/app/components/homepage/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/hosting/app/components/homepage/NavBar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/hosting/app/components/homepage/TestimonialsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/hosting/app/components/homepage/TrendingVenues.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/hosting/app/lib/firebase/app.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/hosting/app/styles.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/hosting/node_modules/next/dist/client/script.js");
